import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const QuickActions = () => {
  const navigate = useNavigate();

  const actions = [
    {
      id: 1,
      title: "Browse Models",
      description: "Explore our 3D model catalog",
      icon: "Search",
      variant: "default",
      path: "/model-catalog"
    },
    {
      id: 2,
      title: "View Cart",
      description: "Check your selected items",
      icon: "ShoppingCart",
      variant: "outline",
      path: "/shopping-cart"
    },
    {
      id: 3,
      title: "3D Viewer",
      description: "Open interactive model viewer",
      icon: "Eye",
      variant: "secondary",
      path: "/3d-model-viewer"
    },

    {
      id: 5,
      icon: 'MessageSquare',
      title: 'My Reviews',
      description: 'View and manage reviews',
      color: 'purple',
      onClick: () => navigate('/product-reviews-ratings')
    },
    {
      id: 6,
      icon: 'Edit',
      title: 'Write Review',
      description: 'Share your experience',
      color: 'orange',
      onClick: () => navigate('/review-submission-form')
    }
  ];

  const renderAction = (action) => {
    const content = (
      <div className="p-4 rounded-lg border border-border hover:border-primary/50 hover:bg-muted/30 transition-smooth group">
        <div className="flex items-start space-x-3">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-smooth">
            <Button
              variant="ghost"
              size="icon"
              iconName={action?.icon}
              className="w-5 h-5 text-primary"
            />
          </div>
          
          <div className="flex-1 min-w-0">
            <h3 className="text-sm font-medium text-foreground group-hover:text-primary transition-smooth">
              {action?.title}
            </h3>
            <p className="text-xs text-muted-foreground mt-1">
              {action?.description}
            </p>
          </div>
        </div>
      </div>
    );

    // Render Link if action has path, otherwise render clickable div with onClick
    if (action?.path) {
      return (
        <Link key={action?.id} to={action?.path} className="block">
          {content}
        </Link>
      );
    } else if (action?.onClick) {
      return (
        <div 
          key={action?.id} 
          onClick={action?.onClick} 
          className="block cursor-pointer"
        >
          {content}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-soft">
      <h2 className="text-xl font-semibold text-foreground mb-6">Quick Actions</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {actions?.map((action) => renderAction(action))}
      </div>
    </div>
  );
};

export default QuickActions;